<div class="fixed top-4 right-4 space-y-2" style="z-index: 101;">
  @for (message of messages; track message.id) {
    <div
      class="toast w-[22rem] h-[6rem] shadow-lg rounded-md p-4 flex justify-between items-center"
      [class]="message.styleClass"
    >
      <l-icon class="absolute !text-2xl top-2 right-4 cursor-pointer" (click)="close(message.id)">close</l-icon>

      <div class="flex items-start">
        <l-icon class="mr-2 !text-3xl">{{ message.icon }}</l-icon>
        <div>
          <h3 class="font-bold">{{ message.summary }}</h3>
          <p>{{ message.detail }}</p>
        </div>
      </div>
    </div>
  }
  
</div>
